// SAVE_STATUS("已保存-未启动", 0),
// SUBMIT_STATUS("已提交-已启动",1),
// STOP_STATUS("停用",2),
// REMOVE_STATUS("删除",3),
// EDIT_STATUS("编辑中-待完成",4),
// FINISH_STATUS("已完成-结束",5),
// WAIT_START_STATUS("待启动",6),
// BE_OVERDUE("已逾期",7),
// NOT_START("未开始",8),
// EDIT_FINISH_START("编辑完成",9);
// RECALL("已撤回", 10);


/**
 * 基本状态总览，绩效基本都用的这一套状态
 */
export const STATUS_MAP = {
    SAVE_STATUS: 0,         // 待完成 | 前台仅保存草稿 | 发起复议如果是0，代表从未发起
    SUBMIT_STATUS: 1,       // 编辑已提交 | 已完成
    EDIT_STATUS: 4,         // 待完成 | 编辑中
    BE_OVERDUE: 7,          // 已逾期
    NOT_START: 8,           // 未开始
    // FIXED: 启用
    // EDIT_FINISH_START: 9,
    RECALL: 10,              // 已撤回
    REJECT_ASSESS: 12         // 拒绝评估
}

/**
 * 状态的筛选项
 */
export const ASSESS_STATUS_OPTIONS = [
    {
        label: '待完成',
        value: STATUS_MAP.EDIT_STATUS
    },
    {
        label: '已完成',
        value: STATUS_MAP.SUBMIT_STATUS
    },
    {
        label: '已逾期',
        value: STATUS_MAP.BE_OVERDUE
    },
]

export const ANNULAR_ASSESS_STATUS_OPTIONS = [
    {
        label: '待完成',
        value: STATUS_MAP.EDIT_STATUS
    },
    {
        label: '已完成',
        value: STATUS_MAP.SUBMIT_STATUS
    },
    {
        label: '已拒绝',
        value: STATUS_MAP.REJECT_ASSESS
    },
    {
        label: '已逾期',
        value: STATUS_MAP.BE_OVERDUE
    },
]
